import getBlockByElement from '../accessors/get-block-by-element';

const isElementBlock = (element) => {
  const block = getBlockByElement(element);

  return Boolean(block);
};

export default isElementBlock;
